import Index from '@/views/common/Index'
import Main from '@/views/common/Main'
import Redirect from '@/views/common/Redirect'

export default [{
  path: '/index',
  name: 'index',
  redirect: 'home',
  meta: {
    auth: true
  },
  component: Index,
  children: [
    // 富文本文件重定向
    {
      path: '/portal/redirect',
      meta: {auth: false, isRedirect: true},
      component: Redirect,
      children: [
        {
          path: '/',
          name: 'portal/redirect',
          meta: {keepAlive: true},
          component: resolve => require(['@/views/common/Redirect'], resolve)
        }
      ]
    },
    //-----------通知通告---------------
    {
      path: '/portal/notice',
      meta: {
        auth: true,
        isRedirect: true,
        title: "通知通告"
      },
      component: Main,
      children: [
        {
          path: '/',
          name: 'portal/notice/noticeList',
          meta: {
            keepAlive: false
          },
          component: resolve => require(['@/views/portal/notice/NoticeList'], resolve)
        },
        {
          path: '/portal/notice/noticeAdd',
          name: 'portal/notice/noticeAdd',
          meta: {
            keepAlive: false,
            auth: true,
					  title: "通知通告新增"
          },
          component: resolve => require(['@/views/portal/notice/NoticeAdd'], resolve)
        },
        {
          path: '/portal/notice/noticeEdit',
          name: 'portal/notice/noticeEdit',
          meta: {
            keepAlive: false,
            auth: true,
					  title: "通知通告编辑"
          },
          component: resolve => require(['@/views/portal/notice/NoticeAdd'], resolve)
        },
        {
          path: '/portal/notice/noticeDetail',
          name: 'portal/notice/noticeDetail',
          meta: {
            keepAlive: false,
            auth: true,
					  title: "通知通告详情"
          },
          component: resolve => require(['@/views/portal/notice/NoticeDetail'], resolve)
        }
      ]
    },
		//-----------重点要闻---------------
		{
		  path: '/portal/keysnews',
		  meta: {
		    auth: true,
				isRedirect: true,
		    title: "新闻中心"
		  },
		  component: Main,
		  children: [{
		    path: '/',
		    name: 'portal/keysnews/keysnewsList',
		    meta: {
		      keepAlive: false,
		    },
		    component: resolve => require(['@/views/portal/keysnews/KeysNewsList'], resolve)
		  },
			{
			  path: '/portal/keysnews/keysnewsAdd',
			  name: 'portal/keysnews/keysnewsAdd',
			  meta: {
			    keepAlive: false,
					auth: true,
					title: "新闻中心新增"
			  },
			  component: resolve => require(['@/views/portal/keysnews/KeysNewsAdd'], resolve)
			},
			{
			  path: '/portal/keysnews/keysnewsEdit',
			  name: 'portal/keysnews/keysnewsEdit',
			  meta: {
			    keepAlive: false,
					auth: true,
					title: "新闻中心编辑"
			  },
			  component: resolve => require(['@/views/portal/keysnews/KeysNewsAdd'], resolve)
			},
			{
			  path: '/portal/keysnews/keysnewsDetails',
			  name: 'portal/keysnews/keysnewsDetails',
			  meta: {
			    keepAlive: false,
					auth: true,
					title: "新闻中心详情"
			  },
			  component: resolve => require(['@/views/portal/keysnews/KeysNewsDetail'], resolve)
			},
			]
		},
		//-----------重点要闻发布---------------
		{
		  path: '/portal/keysnewsRelease',
		  meta: {
		    auth: true,
				isRedirect: true,
		    title: "新闻中心发布"
		  },
		  component: Main,
		  children: [{
		    path: '/',
		    name: 'portal/keysnews/keysnewsReleaseList',
		    meta: {
		      keepAlive: false,
		    },
		    component: resolve => require(['@/views/portal/keysnews/KeysNewsReleaseList'], resolve)
		  },
			{
			  path: '/portal/keysnews/keysnewsReleaseDetails',
			  name: 'portal/keysnews/keysnewsReleaseDetails',
			  meta: {
			    keepAlive: false,
					auth: true,
					title: "新闻中心发布详情"
			  },
			  component: resolve => require(['@/views/portal/keysnews/KeysNewsDetail'], resolve)
			},
			]
		},
    //-----------互动交流---------------
    {
      path: '/portal/interactive',
      meta: {
        auth: true,
    		isRedirect: true,
        title: "互动交流"
      },
      component: Main,
      children: [{
        path: '/',
        name: 'portal/interactive/InteractiveList',
        meta: {
          keepAlive: false,
        },
        component: resolve => require(['@/views/portal/interactive/InteractiveList'], resolve)
      },
    	{
    	  path: '/portal/interactive/InteractiveDetails',
    	  name: 'portal/interactive/InteractiveDetails',
    	  meta: {
    	    keepAlive: false,
    			auth: true,
    			title: "互动交流详情"
    	  },
    	  component: resolve => require(['@/views/portal/interactive/InteractiveDetail'], resolve)
    	},
    	]
    },
		//-----------栏目管理---------------
		{
		  path: '/portal/manage/lm',
		  meta: {
		    auth: true,
		    title: "栏目管理"
		  },
		  component: Main,
		  children: [{
		    path: '/',
		    name: 'portal/manage/ColumnList',
		    meta: {
		      keepAlive: false,
		    },
		    component: resolve => require(['@/views/portal/manage/Column'], resolve)
		  }]
		},
    //-----------理事管理---------------
    {
      path: '/portal/director',
      meta: {
        auth: true,
        title: "理事管理",
        isRedirect: true
      },
      component: Main,
      children: [{
          path: '/',
          name: 'portal/director',
          component: resolve => require(['@/views/portal/director/DirectorList'], resolve)
        },
        {
          path: '/portal/director/directorAdd',
          name: 'portal/director/directorAdd',
          meta: {
            auth: true,
            title: "新增",
            keepAlive: false
          },
          component: resolve => require(['@/views/portal/director/DirectorAdd'], resolve)
        },
        {
          path: '/portal/director/directorEdit',
          name: 'portal/director/directorEdit',
          meta: {
            auth: true,
            title: "编辑",
            keepAlive: false
          },
          component: resolve => require(['@/views/portal/director/DirectorAdd'], resolve)
        },
        {
          path: '/portal/director/directorDetail',
          name: 'portal/director/directorDetail',
          meta: {
            auth: true,
            title: "详情",
            keepAlive: false
          },
          component: resolve => require(['@/views/portal/director/DirectorDetail'], resolve)
        },
        // {
        //   path: '/portal/director/HygrDetail',
        //   name: 'portal/director/HygrDetail',
        //   meta: {
        //     auth: true,
        //     title: "个人会员详情",
        //     keepAlive: false
        //   },
        //   component: resolve => require(['@/views/member/manage/person/HygrDetail'], resolve)
        // },
        // {
        //   path: '/portal/director/HydwDetail',
        //   name: 'portal/director/HydwDetail',
        //   meta: {
        //     auth: true,
        //     title: "单位会员详情",
        //     keepAlive: false
        //   },
        //   component: resolve => require(['@/views/member/manage/company/HydwDetail'], resolve)
        // },
      ]
    },
		//-----------在线投稿---------------
		{
		  path: '/portal/onlinesubmissionDraft',
		  meta: {
		    auth: true,
		    isRedirect: true,
		    title: "在线投稿"
		  },
		  component: Main,
		  children: [
		    {
		      path: '/',
		      name: 'portal/onlinesubmission/onlinesubmissionList',
		      meta: {
		        keepAlive: false
		      },
		      component: resolve => require(['@/views/portal/onlinesubmission/OnlinesubmissionDraftList'], resolve)
		    },
		    {
		      path: '/portal/onlinesubmission/onlinesubmissionAdd',
		      name: 'portal/onlinesubmission/onlinesubmissionAdd',
		      meta: {
		        keepAlive: false,
		        auth: true,
					  title: "在线投稿新增"
		      },
		      component: resolve => require(['@/views/portal/onlinesubmission/OnlinesubmissionAdd'], resolve)
		    },
		    {
		      path: '/portal/onlinesubmission/onlinesubmissionEdit',
		      name: 'portal/onlinesubmission/onlinesubmissionEdit',
		      meta: {
		        keepAlive: false,
		        auth: true,
					  title: "在线投稿编辑"
		      },
		      component: resolve => require(['@/views/portal/onlinesubmission/OnlinesubmissionAdd'], resolve)
		    },
		    {
		      path: '/portal/onlinesubmission/onlinesubmissionDetail',
		      name: 'portal/onlinesubmission/onlinesubmissionDetail',
		      meta: {
		        keepAlive: false,
		        auth: true,
					  title: "在线投稿详情"
		      },
		      component: resolve => require(['@/views/portal/onlinesubmission/OnlinesubmissionDetail'], resolve)
		    }
		  ]
		},
		{
		  path: '/portal/onlinesubmissionApproval',
		  meta: {
		    auth: true,
		    isRedirect: true,
		    title: "在线投稿审核"
		  },
		  component: Main,
		  children: [
		    {
		      path: '/',
		      name: 'portal/onlinesubmission/onlinesubmissionApprovalList',
		      meta: {
		        keepAlive: false
		      },
		      component: resolve => require(['@/views/portal/onlinesubmission/OnlinesubmissionApprovalList'], resolve)
		    },
		    {
		      path: '/portal/onlinesubmission/onlinesubmissionApproval',
		      name: 'portal/onlinesubmission/onlinesubmissionApproval',
		      meta: {
		        keepAlive: false,
		        auth: true,
					  title: "在线投稿审核"
		      },
		      component: resolve => require(['@/views/portal/onlinesubmission/OnlinesubmissionApproval'], resolve)
		    },
				{
				  path: '/portal/onlinesubmission/onlinesubmissionXhAdd',
				  name: 'portal/onlinesubmission/onlinesubmissionXhAdd',
				  meta: {
				    keepAlive: false,
				    auth: true,
					  title: "在线投稿起草"
				  },
				  component: resolve => require(['@/views/portal/onlinesubmission/OnlinesubmissionXhAdd'], resolve)
				},
				{
				  path: '/portal/onlinesubmission/onlinesubmissionApprovalDetail',
				  name: 'portal/onlinesubmission/onlinesubmissionApprovalDetail',
				  meta: {
				    keepAlive: false,
				    auth: true,
					  title: "在线投稿详情"
				  },
				  component: resolve => require(['@/views/portal/onlinesubmission/OnlinesubmissionDetail'], resolve)
				},
				{
				  path: '/portal/onlinesubmission/onlinesubmissionApprovalEdit',
				  name: 'portal/onlinesubmission/onlinesubmissionApprovalEdit',
				  meta: {
				    keepAlive: false,
				    auth: true,
					  title: "在线投稿编辑"
				  },
				  component: resolve => require(['@/views/portal/onlinesubmission/OnlinesubmissionApprovalEdit'], resolve)
				}
		  ]
		},
		//在线投稿协会领导审核
		{
		  path: '/portal/onlinesubmissionXhApproval',
		  meta: {
		    auth: true,
		    isRedirect: true,
		    title: "在线投稿审核"
		  },
		  component: Main,
		  children: [
		    {
		      path: '/',
		      name: 'portal/onlinesubmission/onlinesubmissionXhApprovalList',
		      meta: {
		        keepAlive: false
		      },
		      component: resolve => require(['@/views/portal/onlinesubmission/OnlinesubmissionXhApprovalList'], resolve)
		    },
		    {
		      path: '/portal/onlinesubmission/OnlinesubmissionXhApproval',
		      name: 'portal/onlinesubmission/OnlinesubmissionXhApproval',
		      meta: {
		        keepAlive: false,
		        auth: true,
					  title: "在线投稿审核"
		      },
		      component: resolve => require(['@/views/portal/onlinesubmission/OnlinesubmissionXhApproval'], resolve)
		    },
				{
				  path: '/portal/onlinesubmission/onlinesubmissionXhApprovalDetail',
				  name: 'portal/onlinesubmission/onlinesubmissionXhApprovalDetail',
				  meta: {
				    keepAlive: false,
				    auth: true,
					  title: "在线投稿详情"
				  },
				  component: resolve => require(['@/views/portal/onlinesubmission/OnlinesubmissionXhApprovalDetail'], resolve)
				},
		  ]
		},

    //产品展示
    {
		  path: '/portal/product',
		  meta: {
		    auth: true,
		    isRedirect: true,
		    title: "产品展示"
		  },
		  component: Main,
		  children: [
		    {
		      path: '/',
		      name: 'portal/product/productEdit',
		      meta: {
		        keepAlive: false
		      },
		      component: resolve => require(['@/views/portal/product/ProductEdit'], resolve)
		    },
		  ]
		},
		//产品展示审核
    {
		  path: '/portal/productApprove',
		  meta: {
		    auth: true,
		    isRedirect: true,
		    title: "产品展示审核"
		  },
		  component: Main,
		  children: [
		    {
		      path: '/',
		      name: 'portal/productApprove/productApproveList',
		      meta: {
		        keepAlive: false
		      },
		      component: resolve => require(['@/views/portal/product/approve/ProductApproveList'], resolve)
		    },
				{
		      path: '/portal/productApprove/productApproveDetail',
		      name: 'portal/productApprove/productApproveDetail',
		      meta: {
		        keepAlive: false,
						auth: true,
					  title: "详情"
		      },
		      component: resolve => require(['@/views/portal/product/approve/ProductApproveDetail'], resolve)
		    },
				{
		      path: '/portal/productApprove/approve',
		      name: 'portal/productApprove/approve',
		      meta: {
		        keepAlive: false,
						auth: true,
					  title: "审核"
		      },
		      component: resolve => require(['@/views/portal/product/approve/ProductApprove'], resolve)
		    },
		  ]
		},
    //会员简介
		{
		  path: '/portal/memberIntroduction',
		  meta: {
		    auth: true,
		    isRedirect: true,
		    title: "会员简介"
		  },
		  component: Main,
		  children: [
		    {
		      path: '/',
		      name: 'portal/memberIntroduction/MemberIntroductionAdd',
		      meta: {
		        keepAlive: false
		      },
		      component: resolve => require(['@/views/portal/memberIntroduction/MemberIntroductionAdd'], resolve)
		    },
		  ]
		},
    //会员简介审核
    {
		  path: '/portal/memberIntroductionApprove',
		  meta: {
		    auth: true,
		    isRedirect: true,
		    title: "会员简介审核"
		  },
		  component: Main,
		  children: [
		    {
		      path: '/',
		      name: 'portal/memberIntroductionApprove/memberIntroductionApproveList',
		      meta: {
		        keepAlive: false
		      },
		      component: resolve => require(['@/views/portal/memberIntroduction/approve/MemberIntroductionApprovalList'], resolve)
		    },
        {
		      path: '/portal/memberIntroductionApprove/memberIntroductionApproveDetail',
		      name: 'portal/memberIntroductionApprove/memberIntroductionApproveDetail',
		      meta: {
		        keepAlive: false,
		        auth: true,
					  title: "会员简介详情"
		      },
		      component: resolve => require(['@/views/portal/memberIntroduction/approve/MemberIntroductionXhApprovalDetail'], resolve)
		    },
		    {
		      path: '/portal/memberIntroductionApprove/memberIntroductionApproval',
		      name: 'portal/memberIntroductionApprove/memberIntroductionApproval',
		      meta: {
		        keepAlive: false,
		        auth: true,
					  title: "会员简介审核"
		      },
		      component: resolve => require(['@/views/portal/memberIntroduction/approve/MemberIntroductionApprove'], resolve)
		    },
				{
		      path: '/portal/memberIntroductionApprove/MemberIntroductionApproveAdd',
		      name: 'portal/memberIntroductionApprove/MemberIntroductionApproveAdd',
		      meta: {
		        keepAlive: false,
		        auth: true,
					  title: "会员简介新增"
		      },
		      component: resolve => require(['@/views/portal/memberIntroduction/approve/MemberIntroductionApproveAdd'], resolve)
		    },
				{
		      path: '/portal/memberIntroductionApprove/MemberIntroductionApproveEdit',
		      name: 'portal/memberIntroductionApprove/MemberIntroductionApproveEdit',
		      meta: {
		        keepAlive: false,
		        auth: true,
					  title: "会员简介编辑"
		      },
		      component: resolve => require(['@/views/portal/memberIntroduction/approve/MemberIntroductionApproveAdd'], resolve)
		    },
		  ]
		},
		//会员简介审核
    {
		  path: '/portal/memberIntroductionXhApprove',
		  meta: {
		    auth: true,
		    isRedirect: true,
		    title: "会员简介审核"
		  },
		  component: Main,
		  children: [
		    {
		      path: '/',
		      name: 'portal/memberIntroductionXhApprove/memberIntroductionXhApproveList',
		      meta: {
		        keepAlive: false
		      },
		      component: resolve => require(['@/views/portal/memberIntroduction/approve/MemberIntroductionXhApprovalList'], resolve)
		    },
				{
		      path: '/portal/memberIntroductionXhApprove/memberIntroductionXhApprovalDetail',
		      name: 'portal/memberIntroductionXhApprove/memberIntroductionXhApprovalDetail',
		      meta: {
		        keepAlive: false,
		        auth: true,
					  title: "会员简介详情"
		      },
		      component: resolve => require(['@/views/portal/memberIntroduction/approve/MemberIntroductionXhApprovalDetail'], resolve)
		    },
				{
		      path: '/portal/memberIntroductionXhApprove/memberIntroductionXhApproval',
		      name: 'portal/memberIntroductionXhApprove/memberIntroductionXhApproval',
		      meta: {
		        keepAlive: false,
		        auth: true,
					  title: "会员简介审核"
		      },
		      component: resolve => require(['@/views/portal/memberIntroduction/approve/MemberIntroductionXhApproval'], resolve)
		    },
		  ]
		},
    //-----------常用链接---------------
    {
      path: '/portal/commonlyUsedLinks',
      meta: {
        auth: true,
        isRedirect: true,
        title: "常用链接"
      },
      component: Main,
      children: [
        {
          path: '/',
          name: 'portal/commonlyUsedLinks',
          meta: {
            keepAlive: false
          },
          component: resolve => require(['@/views/portal/manage/Link'], resolve)
        },
      ]
    },
    //-----------二维码上传---------------
    {
      path: '/portal/ewm/Qewm',
      meta: {
        auth: true,
        isRedirect: true,
        title: "群二维码"
      },
      component: Main,
      children: [
        {
          path: '/',
          name: 'portal/ewm/Qewm',
          meta: {
            keepAlive: false
          },
          component: resolve => require(['@/views/portal/ewm/Qewm'], resolve)
        },
      ]
    },
		//-----------行业标准---------------
		{
		  path: '/portal/industrystandard',
		  meta: {
		    auth: true,
				isRedirect: true,
		    title: "行业标准"
		  },
		  component: Main,
		  children: [{
		    path: '/',
		    name: 'portal/industrystandard/industrystandardList',
		    meta: {
		      keepAlive: false,
		    },
		    component: resolve => require(['@/views/portal/standard/StandardList'], resolve)
		  },
			{
			  path: '/portal/industrystandard/industrystandardAdd',
			  name: 'portal/industrystandard/industrystandardAdd',
			  meta: {
			    keepAlive: false,
					auth: true,
					title: "行业标准新增"
			  },
			  component: resolve => require(['@/views/portal/standard/StandardAdd'], resolve)
			},
			{
			  path: '/portal/industrystandard/industrystandardEdit',
			  name: 'portal/industrystandard/industrystandardEdit',
			  meta: {
			    keepAlive: false,
					auth: true,
					title: "行业标准编辑"
			  },
			  component: resolve => require(['@/views/portal/standard/StandardAdd'], resolve)
			},
			{
			  path: '/portal/industrystandard/industrystandardDetails',
			  name: 'portal/industrystandard/industrystandardDetails',
			  meta: {
			    keepAlive: false,
					auth: true,
					title: "行业标准详情"
			  },
			  component: resolve => require(['@/views/portal/standard/StandardDetail'], resolve)
			},
			]
		},
		//-----------政策法规---------------
		{
		  path: '/portal/regulations',
		  meta: {
		    auth: true,
				isRedirect: true,
		    title: "政策法规"
		  },
		  component: Main,
		  children: [{
		    path: '/',
		    name: 'portal/regulations/regulationsList',
		    meta: {
		      keepAlive: false,
		    },
		    component: resolve => require(['@/views/portal/regulations/RegulationsList'], resolve)
		  },
			{
			  path: '/portal/regulations/regulationsAdd',
			  name: 'portal/regulations/regulationsAdd',
			  meta: {
			    keepAlive: false,
					auth: true,
					title: "政策法规新增"
			  },
			  component: resolve => require(['@/views/portal/regulations/RegulationsAdd'], resolve)
			},
			{
			  path: '/portal/regulations/regulationsEdit',
			  name: 'portal/regulations/regulationsEdit',
			  meta: {
			    keepAlive: false,
					auth: true,
					title: "政策法规编辑"
			  },
			  component: resolve => require(['@/views/portal/regulations/RegulationsAdd'], resolve)
			},
			{
			  path: '/portal/regulations/regulationsDetails',
			  name: 'portal/regulations/regulationsDetails',
			  meta: {
			    keepAlive: false,
					auth: true,
					title: "政策法规详情"
			  },
			  component: resolve => require(['@/views/portal/regulations/RegulationsDetail'], resolve)
			},
			]
		},
    //-----------文稿设置---------------
    {
      path: '/portal/draft',
      meta: {
        auth: true,
        isRedirect: true,
        title: "文稿设置"
      },
      component: Main,
      children: [
        {
          path: '/',
          name: 'portal/draft',
          meta: {
            keepAlive: false
          },
          component: resolve => require(['@/views/portal/manage/DraftList'], resolve)
        },
        {
          path: '/portal/draft/draftAdd',
          name: 'portal/draft/draftAdd',
          meta: {
            keepAlive: false,
            auth: true,
					  title: "文稿设置新增"
          },
          component: resolve => require(['@/views/portal/manage/DraftAdd'], resolve)
        },
        {
          path: '/portal/draft/draftEdit',
          name: 'portal/draft/draftEdit',
          meta: {
            keepAlive: false,
            auth: true,
					  title: "文稿设置编辑"
          },
          component: resolve => require(['@/views/portal/manage/DraftAdd'], resolve)
        },
      ]
    },
		//-----------常见问题---------------
    {
      path: '/portal/faq',
      meta: {
        auth: true,
        isRedirect: true,
        title: "常见问题"
      },
      component: Main,
      children: [
        {
          path: '/',
          name: 'portal/faq',
          meta: {
            keepAlive: false
          },
          component: resolve => require(['@/views/portal/manage/FAQ'], resolve)
        },
      ]
    },
		//-----------资料下载---------------
    {
      path: '/portal/dataDownload',
      meta: {
        auth: true,
        isRedirect: true,
        title: "资料下载"
      },
      component: Main,
      children: [
        {
          path: '/',
          name: 'portal/dataDownload',
          meta: {
            keepAlive: false
          },
          component: resolve => require(['@/views/portal/manage/Download'], resolve)
        },
      ]
    },
    //-----------重点要闻审核---------------
		{
		  path: '/portal/keysnewsApproval',
		  meta: {
		    auth: true,
				isRedirect: true,
		    title: "新闻中心审核"
		  },
		  component: Main,
		  children: [{
		    path: '/',
		    name: 'portal/keysnewsApproval',
		    meta: {
		      keepAlive: false,
		    },
		    component: resolve => require(['@/views/portal/keysnews/approve/KeysNewsApproveList'], resolve)
		  },
			{
			  path: '/portal/keysnewsApproval/keysnewsDetails',
			  name: 'portal/keysnewsApproval/keysnewsDetails',
			  meta: {
			    keepAlive: false,
					auth: true,
					title: "新闻中心详情"
			  },
			  component: resolve => require(['@/views/portal/keysnews/KeysNewsDetail'], resolve)
			},
      {
			  path: '/portal/keysnewsApproval/approve',
			  name: 'portal/keysnewsApproval/approve',
			  meta: {
			    keepAlive: false,
					auth: true,
					title: "审核"
			  },
			  component: resolve => require(['@/views/portal/keysnews/approve/Approve'], resolve)
			},
			]
		},
  ]
}]



// WEBPACK FOOTER //
// ./src/router/portal.js